"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBtcTimeCellsSpent = exports.signBtcTimeCellSpentTx = exports.buildBtcTimeCellsSpentTx = exports.buildBtcTimeUnlockWitness = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const constants_1 = require("../constants");
const rgbpp_1 = require("../schemas/generated/rgbpp");
const utils_1 = require("../utils");
const utils_2 = require("../utils");
const base_1 = require("@ckb-lumos/base");
const signWitnesses_1 = __importDefault(require("@nervosnetwork/ckb-sdk-core/lib/signWitnesses"));
const buildBtcTimeUnlockWitness = (btcTxProof) => {
    const btcTimeUnlock = rgbpp_1.BTCTimeUnlock.pack({ btcTxProof: base_1.blockchain.Bytes.pack(btcTxProof) });
    return (0, utils_1.append0x)((0, ckb_sdk_utils_1.bytesToHex)(btcTimeUnlock));
};
exports.buildBtcTimeUnlockWitness = buildBtcTimeUnlockWitness;
/**
 * Collect btc time cells and spend them to create xUDT cells for the specific lock scripts in the btc time lock args
 * The btc time lock args data structure is: lock_script | after | new_bitcoin_tx_id
 * @param btcTimeCells The BTC time cells of xUDT
 * @param btcAssetsApi BTC Assets Api
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const buildBtcTimeCellsSpentTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ btcTimeCells, btcAssetsApi, isMainnet, btcTestnetType, }) {
    var _b, e_1, _c, _d;
    const sortedBtcTimeCells = btcTimeCells.sort(utils_1.compareInputs);
    const inputs = sortedBtcTimeCells.map((cell) => ({
        previousOutput: cell.outPoint,
        since: '0x0',
    }));
    const outputs = sortedBtcTimeCells.map((cell) => ({
        lock: (0, utils_1.lockScriptFromBtcTimeLockArgs)(cell.output.lock.args),
        type: cell.output.type,
        capacity: cell.output.capacity,
    }));
    const outputsData = sortedBtcTimeCells.map((cell) => cell.outputData);
    const cellDeps = yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { btcTime: true, xudt: true }, btcTestnetType);
    const witnesses = [];
    const lockArgsSet = new Set();
    const cellDepsSet = new Set();
    try {
        for (var _e = true, sortedBtcTimeCells_1 = __asyncValues(sortedBtcTimeCells), sortedBtcTimeCells_1_1; sortedBtcTimeCells_1_1 = yield sortedBtcTimeCells_1.next(), _b = sortedBtcTimeCells_1_1.done, !_b; _e = true) {
            _d = sortedBtcTimeCells_1_1.value;
            _e = false;
            const btcTimeCell = _d;
            if (lockArgsSet.has(btcTimeCell.output.lock.args)) {
                witnesses.push('0x');
                continue;
            }
            lockArgsSet.add(btcTimeCell.output.lock.args);
            const { btcTxId, after } = (0, utils_1.btcTxIdAndAfterFromBtcTimeLockArgs)(btcTimeCell.output.lock.args);
            const result = yield btcAssetsApi.getRgbppSpvProof(btcTxId, after);
            const { spvClient, proof } = (0, utils_1.transformSpvProof)(result);
            if (!cellDepsSet.has((0, ckb_sdk_utils_1.serializeOutPoint)(spvClient))) {
                cellDeps.push((0, utils_2.buildSpvClientCellDep)(spvClient));
                cellDepsSet.add((0, ckb_sdk_utils_1.serializeOutPoint)(spvClient));
            }
            const btcTimeWitness = (0, utils_1.append0x)((0, ckb_sdk_utils_1.serializeWitnessArgs)({ lock: (0, exports.buildBtcTimeUnlockWitness)(proof), inputType: '', outputType: '' }));
            witnesses.push(btcTimeWitness);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_e && !_b && (_c = sortedBtcTimeCells_1.return)) yield _c.call(sortedBtcTimeCells_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    const ckbTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    return ckbTx;
});
exports.buildBtcTimeCellsSpentTx = buildBtcTimeCellsSpentTx;
/**
 * Sign the BTC time cells spent transaction with Secp256k1 private key
 * @param secp256k1PrivateKey The Secp256k1 private key of the master address
 * @param ckbRawTx The CKB raw transaction to be signed
 * @param collector The collector that collects CKB live cells and transactions
 * @param masterCkbAddress The master CKB address
 * @param outputCapacityRange(Optional) [u64; 2], filter cells by output capacity range, [inclusive, exclusive]
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet
 */
const signBtcTimeCellSpentTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ secp256k1PrivateKey, ckbRawTx, collector, masterCkbAddress, isMainnet, outputCapacityRange, ckbFeeRate, }) {
    const masterLock = (0, ckb_sdk_utils_1.addressToScript)(masterCkbAddress);
    let emptyCells = yield collector.getCells({
        lock: masterLock,
        outputCapacityRange,
    });
    if (!emptyCells || emptyCells.length === 0) {
        throw new Error('No empty cell found');
    }
    emptyCells = emptyCells.filter((cell) => !cell.output.type);
    const emptyInput = {
        previousOutput: emptyCells[0].outPoint,
        since: '0x0',
    };
    const changeOutput = emptyCells[0].output;
    const rawTx = Object.assign(Object.assign({}, ckbRawTx), { cellDeps: [...ckbRawTx.cellDeps, (0, constants_1.getSecp256k1CellDep)(isMainnet)], inputs: [emptyInput, ...ckbRawTx.inputs], outputs: [changeOutput, ...ckbRawTx.outputs], outputsData: ['0x', ...ckbRawTx.outputsData], witnesses: [{ lock: '', inputType: '', outputType: '' }, ...ckbRawTx.witnesses] });
    const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(rawTx) + constants_1.SECP256K1_WITNESS_LOCK_SIZE;
    const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
    const changeCapacity = BigInt(emptyCells[0].output.capacity) - estimatedTxFee;
    rawTx.outputs[0].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    const keyMap = new Map();
    keyMap.set((0, ckb_sdk_utils_1.scriptToHash)(masterLock), secp256k1PrivateKey);
    const cells = rawTx.inputs.map((input, index) => ({
        outPoint: input.previousOutput,
        lock: index === 0 ? masterLock : (0, constants_1.getBtcTimeLockScript)(isMainnet),
    }));
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(rawTx);
    const signedWitnesses = (0, signWitnesses_1.default)(keyMap)({
        transactionHash,
        witnesses: rawTx.witnesses,
        inputCells: cells,
        skipMissingKeys: true,
    });
    const signedTx = Object.assign(Object.assign({}, rawTx), { witnesses: signedWitnesses.map((witness) => typeof witness !== 'string' ? (0, ckb_sdk_utils_1.serializeWitnessArgs)(witness) : witness) });
    return signedTx;
});
exports.signBtcTimeCellSpentTx = signBtcTimeCellSpentTx;
/**
 * Check if the BTC time cells have been spent. If so, it means the RGB++ asset jumping(from BTC to CKB) has been successful.
 * @param collector The collector that collects CKB live cells and transactions
 * @param ckbAddress The CKB address
 * @param btcTxId The BTC transaction id
 */
const isBtcTimeCellsSpent = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, ckbAddress, btcTxId, btcTestnetType, }) {
    const isMainnet = ckbAddress.startsWith('ckb');
    const lock = (0, ckb_sdk_utils_1.addressToScript)(ckbAddress);
    const btcTimeLock = Object.assign(Object.assign({}, (0, constants_1.getBtcTimeLockScript)(isMainnet, btcTestnetType)), { args: (0, utils_1.genBtcTimeLockArgs)(lock, btcTxId, constants_1.BTC_JUMP_CONFIRMATION_BLOCKS) });
    const btcTimeCells = yield collector.getCells({ lock: btcTimeLock, isDataMustBeEmpty: false });
    const isSpent = !btcTimeCells || btcTimeCells.length === 0;
    return isSpent;
});
exports.isBtcTimeCellsSpent = isBtcTimeCellsSpent;
